import React, { useMemo, useState } from "react";
import { Button, Empty } from "antd";
import { Container } from "react-bootstrap";
import CmsTopBar from "components/cmslayout/CmsTopBar";
import ReviewCard from "./components/ReviewCard";
import SectionHeader from "./components/SectionHeader";
import { reviewData } from "./mockData";

type ReviewFilter = "all" | "flagged";

const ReviewsPage: React.FC = () => {
  const [filter, setFilter] = useState<ReviewFilter>("all");

  const filteredReviews = useMemo(() => {
    if (filter === "flagged") {
      return reviewData.filter((review) => review.rating <= 2);
    }
    return reviewData;
  }, [filter]);

  return (
    <React.Fragment>
      <CmsTopBar title="Reviews" />

      <Container fluid className="dashboard-wrap">
        <Container fluid className="px-3 py-4">
          <div className="data-lite-page">
            <SectionHeader
              title="User Reviews & Feedback Loop"
              description="Buyer feedback with low-rating reviews available in a focused view."
              action={
                <div className="review-filter-group" aria-label="Review filter">
                  <Button
                    type={filter === "all" ? "primary" : "default"}
                    onClick={() => setFilter("all")}
                  >
                    All Reviews
                  </Button>
                  <Button
                    type={filter === "flagged" ? "primary" : "default"}
                    onClick={() => setFilter("flagged")}
                  >
                    Flagged Reviews
                  </Button>
                </div>
              }
            />

            {filteredReviews.length === 0 ? (
              <div className="data-lite-empty">
                <Empty description="No reviews match this filter." />
              </div>
            ) : (
              <div className="review-list">
                {filteredReviews.map((review) => (
                  <ReviewCard key={review.id} review={review} />
                ))}
              </div>
            )}
          </div>
        </Container>
      </Container>
    </React.Fragment>
  );
};

export default ReviewsPage;
